import { BaseApiService } from '@/services/base-service';
import { BaseResponse, Filters, FiltersPagination } from '@/types';
import { PartnerProducts } from '../types';

interface PartnerProd extends BaseResponse {
  data: PartnerProducts.Item,
}

export class PartnerProductsService extends BaseApiService {
  private readonly base_path = 'products-local';

  async get_partner_products(payload: PartnerProducts.Request): Promise<PartnerProducts.Response> {
    const { data } = await this.http_client.get<PartnerProducts.Response>(this.base_path, {
      params: {
        filters: payload.filters,
        filters_exist: true,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    return data;
  }

  async create_partner_products(payload: FormData): Promise<PartnerProd> {
    const { data } = await this.http_client.post(this.base_path, payload);

    return data;
  }
}

export const default_partner_product = (): PartnerProducts.NewItem => ({
  nomenclature: null,
  product_code: null,
  product_image: null,
  price: null,
  description: null,
});
